import {Component, Input, OnDestroy} from '@angular/core';
import {TorchUser} from '@backend/modules/@users/models/torch-user.model';
import {takeUntil} from 'rxjs/operators';
import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {TorchUserService} from '@backend/modules/@users/services/torch-user.service';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({opacity: 0}),
        animate(300, style({opacity: 1}))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(50, style({opacity: 0}))
      ])
    ])
  ]
})
export class UserInfoComponent implements OnDestroy {

  hasLoaded = new BehaviorSubject<boolean>(false);
  currentUser: TorchUser;
  currentUserProfilePicture: string;
  sessionUser: TorchUser;

  @Input()
  set small(value: boolean|string) {
    if (value === 'true') {
      this._small = true;
    } else if (value === 'false') {
      this._small = false;
    } else {
      this._small = value as boolean;
    }
  }

  _small = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private torchUserService: TorchUserService) {
    this.hasLoaded.next(false);
    this.torchUserService.currentTorchUser.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(sessionUser => this.sessionUser = sessionUser);
  }
  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  get contactLinkAddress() {
    return `mailto:${this.currentUser.username}`;
  }

  get isSessionUser(): boolean {
    if (!!this.sessionUser) {
      return this.sessionUser.username === this.currentUser.username;
    }

    return false;
  }


  @Input()
  set user(newValue: TorchUser | null) {
    this.hasLoaded.next(false);

    if (!!newValue) {
      this.currentUser = newValue;
      this.torchUserService.getUserAvatar(newValue.username).pipe(
        takeUntil(this.destroyed$)
      ).subscribe( avatar => {
        this.currentUserProfilePicture = avatar;
        this.hasLoaded.next(true);
      });
    }
  }

}
